import {ActionTree} from "vuex";
import {SupportModuleState} from "@/modules/support/store/index";
import {RootState} from "@/store/types";
import * as api from '@/modules/support/api'
import {MutationTypes} from "@/modules/support/store/mutations";
import Category from "@/modules/support/model/Category";
import Step from "@/modules/support/model/Step";
import Guide from "@/modules/support/model/Guide";

const actions: ActionTree<SupportModuleState, RootState> = {
    /**
     * Carga la categoría raíz de guías de soporte y todas sus hijas
     */
    async loadRootCategory({commit}) {
        const category = await api.getCategory(1)

        commit(MutationTypes.SET_ROOT_CATEGORY, category)
    },
    /**
     * Actualiza la categoría actualmente seleccionada por el usuario
     *
     * @param state
     * @param commit
     */
    async saveCategory({state, commit}) {
        let category = state.currentCategory
        if (!category) {
            throw new Error('No hay ninguna categoría para actualizar')
        }

        const isNew = category.isNew
        category = isNew
            ? await api.createCategory(category)
            : await api.updateCategory(category)

        commit(MutationTypes.SET_CURRENT_CATEGORY, category)
        commit(MutationTypes.REMOVE_CATEGORY, isNew ? 0 : category.id)
        commit(MutationTypes.ADD_CATEGORY, category)
    },
    /**
     * Crea una nueva entidad Categoría y la inserta en el árbol.
     */
    createCategory({commit}, parent: number) {
        const category = new Category()
        category.parent = parent

        commit(MutationTypes.ADD_CATEGORY, category)
        commit(MutationTypes.SET_CURRENT_CATEGORY, category)
    },
    /*
     * Cambia la categoría padre de una categoría
     *
     * @param commit
     * @param { number } newParent
     * @param { Category } category
     */
    async changeCategoryParent({commit}, {newParent, category}) {
        category.parent = newParent
        const updated = await api.updateCategory(category)
        commit(MutationTypes.ADD_CATEGORY, updated)
    },
    /**
     * Carga una paginación guías en el servidor
     */
    async loadGuidePagination({state, commit}) {
        const pagination = await api.getCategoryList(state.guidePaginationInput)

        commit(MutationTypes.SET_GUIDE_PAGINATION, pagination)
    },
    /**
     * Carga una guía y la establece como guía actualmente selecciona por
     * el usuario
     */
    async loadGuide({commit}, id: number) {
        const guide = await api.getGuide(id)
        commit(MutationTypes.SET_CURRENT_GUIDE, guide)
    },
    /**
     * Crea un nuevo paso para la guía
     *
     * @param state
     * @param commit
     */
    createStep({state, commit}) {
        const step = new Step()
        step.order = state.currentGuide.nextPosition

        commit(MutationTypes.SET_CURRENT_STEP, step)
    },
    /**
     * Guarda en la guía los cambios realizados en un determinado paso
     *
     * @param state
     */
    saveStep({state}) {
        state.currentGuide.addStep(state.currentStep)
    },
    /**
     * Crea una nueva guía y la inserta como guía actualmente en edición
     */
    createGuide({commit}) {
        commit(MutationTypes.SET_CURRENT_GUIDE, new Guide())
    },
    /**
     * Actualiza los cambios de la guía actualmente en edición
     */
    async saveGuide({state, commit}) {
        let guide = state.currentGuide
        guide = guide.isNew ? await api.crateGuide(guide) : await api.updateGuide(guide)

        commit(MutationTypes.SET_CURRENT_GUIDE, guide)
    },
    /**
     * Elimina la guía actualmente seleccionada por el usuario
     */
    async deleteGuide({commit, state}) {
        const guide = state.currentGuide
        if (!guide.id) {
            return
        }

        const result = await api.deleteGuide(guide.id)
        if (!result) {
            return
        }

        commit(MutationTypes.SET_CURRENT_GUIDE, new Guide())
    },
    /**
     * Carga una paginación de visitas a guías
     */
    async loadGuideViewPagination({state, commit}) {
        const pagination = await api.getGuideViewList(state.guideViewPaginationInput)
        commit(MutationTypes.SET_GUIDE_VIEW_PAGINATION, pagination)
    },
    /**
     * Elimina la categoría actualmente selecciona por el usuario
     *
     * @param commit
     * @param state
     */
    async deleteCategory({commit, state}) {
        const category = state.currentCategory
        const replacement = state.replacementCategory

        if (!category || !category.id) {
            return
        }

        await api.deleteCategory(category.id, {
            replacementCategory: replacement && replacement.id ? replacement.id : 0,
        })

        commit(MutationTypes.SET_CURRENT_CATEGORY, null)
        commit(MutationTypes.SET_REPLACEMENT_CATEGORY, null)
        commit(MutationTypes.REMOVE_CATEGORY, category.id)
    },
    /**
     * Carga la lista de pantallas
     *
     * @param commit
     */
    async loadScreens ({commit}) {
        commit(MutationTypes.SET_SCREEN_LIST, await api.getScreenList())
    },
}

export default actions
